import { DataListItem } from '@brighte/form-components';
import { EnterpriseStructure } from '@brighte/validation';
import { getEnumKey } from '@components/StepNavigator/helper';
import { useApplicationData } from '@provider';
import { formatAddress, pascalToCamelCase } from '@utils';

export const useGuarantorDetailsSummary = (): { title: string; items: DataListItem[] }[] => {
  const guarantorDetails = useApplicationData('GuarantorDetails');

  if (!guarantorDetails?.enterprise?.structure) return [];

  const structure = guarantorDetails.enterprise.structure;
  const structureProp = pascalToCamelCase(getEnumKey(structure, EnterpriseStructure));
  const directors = guarantorDetails.enterprise[structureProp]?.directors;
  const validGuarantors = directors?.filter(g => g?.isGuarantor);

  if (!validGuarantors || validGuarantors.length === 0) return [];

  return validGuarantors.map((guarantor, index) => ({
    title: `Guarantor ${index + 1}`,
    items: [
      { label: 'Name', value: `${guarantor?.firstName ?? ''} ${guarantor?.lastName ?? ''}` },
      { label: 'Home address', value: guarantor?.address ? formatAddress(guarantor.address) : '' },
    ],
  }));
};
